var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNounHotel3918347222222(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 940.9",
    style: {
      enableBackground: "new 0 0 1200 940.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#222222;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M450,199.3h-31.2c-13.2,0-24,10.8-24,24v68.4c0,13.2,10.8,24,24,24H450c13.2,0,24-10.8,24-24v-68.4 C474,210.1,463.2,199.3,450,199.3L450,199.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M615.6,199.3h-31.2c-13.2,0-24,10.8-24,24v68.4c0,13.2,10.8,24,24,24h31.2c13.2,0,24-10.8,24-24v-68.4 C639.6,210.1,628.8,199.3,615.6,199.3L615.6,199.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M781.2,199.3H750c-13.2,0-24,10.8-24,24v68.4c0,13.2,10.8,24,24,24h31.2c13.2,0,24-10.8,24-24v-68.4 C805.2,210.1,794.4,199.3,781.2,199.3L781.2,199.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M450,412.9h-31.2c-13.2,0-24,10.8-24,24v68.4c0,13.2,10.8,24,24,24H450c13.2,0,24-10.8,24-24v-68.4 C474,423.7,463.2,412.9,450,412.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M615.6,412.9h-31.2c-13.2,0-24,10.8-24,24v68.4c0,13.2,10.8,24,24,24h31.2c13.2,0,24-10.8,24-24v-68.4 C639.6,423.7,628.8,412.9,615.6,412.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M781.2,412.9H750c-13.2,0-24,10.8-24,24v68.4c0,13.2,10.8,24,24,24h31.2c13.2,0,24-10.8,24-24v-68.4 C805.2,423.7,794.4,412.9,781.2,412.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M450,627.7h-31.2c-13.2,0-24,10.8-24,24v68.4c0,13.2,10.8,24,24,24H450c13.2,0,24-10.8,24-24v-68.4 C474,638.5,463.2,627.7,450,627.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M615.6,627.7h-31.2c-13.2,0-24,10.8-24,24v68.4c0,13.2,10.8,24,24,24h31.2c13.2,0,24-10.8,24-24v-68.4 C639.6,638.5,628.8,627.7,615.6,627.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M781.2,627.7H750c-13.2,0-24,10.8-24,24v68.4c0,13.2,10.8,24,24,24h31.2c13.2,0,24-10.8,24-24v-68.4 C805.2,638.5,794.4,627.7,781.2,627.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1015.2,844.9h-63.6V123.7c0-50.4-40.8-92.4-92.4-92.4H339.6c-50.4,0-92.4,40.8-92.4,92.4v721.2h-63.6 c-18,0-33.6,14.4-33.6,33.6c0,18,14.4,33.6,33.6,33.6h829.2c18,0,33.6-14.4,33.6-33.6C1047.6,859.3,1033.2,844.9,1015.2,844.9 L1015.2,844.9z M885.6,844.9H314.4V123.7c0-14.4,12-26.4,26.4-26.4h519.6c14.4,0,26.4,12,26.4,26.4v721.2H885.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounHotel3918347222222);
export default __webpack_public_path__ + "static/media/noun-hotel-3918347-222222.74d94f8d76b34c83f2352281f0f8d86d.svg";
export { ForwardRef as ReactComponent };